import { render, staticRenderFns } from "./link-document-item-img.vue?vue&type=template&id=b0f9c6d2&"
import script from "./link-document-item-img.vue?vue&type=script&lang=js&"
export * from "./link-document-item-img.vue?vue&type=script&lang=js&"
import style0 from "./link-document-item-img.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports